import { Send, ExternalLink } from "lucide-react";
import { DiscordIcon } from "@/components/DiscordIcon";
import { LOGO_URL, DISCORD_URL } from "@/data/content";

export const TelegramSection = () => (
    <div className="fade-in" data-testid="telegram-section">
      <div className="text-center mb-16">
        <div className="inline-flex justify-center mb-8">
          <div className="relative">
            <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-2xl"></div>
            <img 
              src={LOGO_URL} 
              alt="Logo Telegram 700S ICT" 
              className="relative w-32 h-32 sm:w-40 sm:h-40 rounded-full border-4 border-white/20 shadow-2xl"
              data-testid="telegram-logo"
            />
          </div>
        </div>
        
        <h2 className="text-4xl sm:text-6xl font-bold mb-10 text-balance max-w-4xl mx-auto" data-testid="telegram-title">
          Bienvenue dans le monde du CRT&nbsp;x&nbsp;ICT
        </h2>
        <p className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto mb-12">
          Rejoignez la communauté.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10 max-w-[48rem] mx-auto">
        <div className="p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all flex flex-col items-center text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Send size={32} className="text-blue-400" />
            <h3 className="text-2xl font-bold" data-testid="telegram-channel-title">Canal Public</h3>
          </div>
          <p className="text-white/70 mb-6">
            Trader n°1 CRT FR 🌹
          </p>
          <a
            href="https://t.me/+y6sB75H32qI2OWI0"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 hover:scale-105 transition-all"
            data-testid="telegram-channel-button"
          >
            Rejoindre le Canal
            <ExternalLink size={18} />
          </a>
          <p className="mt-4 text-sm text-white/50 flex items-center justify-center gap-2">
            +2 000 membres actifs
            <span className="live-dot live-dot-blue" data-testid="telegram-channel-live-dot"></span>
          </p>
        </div>

        <div className="p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all flex flex-col items-center text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Send size={32} className="text-green-400" />
            <h3 className="text-2xl font-bold whitespace-nowrap" data-testid="telegram-group-title">Groupe de Discussion</h3>
          </div>
          <p className="text-white/70 mb-6">
            Discutez avec la communauté 💬
          </p>
          <a
            href="https://t.me/groupepublic700s"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 text-white font-bold rounded-lg hover:bg-green-600 hover:scale-105 transition-all"
            data-testid="telegram-group-button"
          >
            Rejoindre le Groupe
            <ExternalLink size={18} />
          </a>
          <p className="mt-4 text-sm text-white/50 flex items-center justify-center gap-2">
            +800 membres actifs
            <span className="live-dot" data-testid="telegram-group-live-dot"></span>
          </p>
        </div>
      </div>

      <div className="mt-16 w-fit max-w-full mx-auto px-6 py-5 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all flex flex-col items-center text-center" data-testid="discord-backup">
        <div className="flex items-center justify-center gap-2 mb-4">
          <DiscordIcon className="w-6 h-6 shrink-0 text-[#5865F2]" />
          <h3 className="text-base font-bold whitespace-nowrap" data-testid="discord-title">Serveur Discord de secours (backup)</h3>
        </div>
        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 text-sm bg-[#5865F2] text-white font-bold rounded-lg hover:bg-[#4752C4] hover:scale-105 transition-all"
          data-testid="discord-backup-link"
        >
          Rejoindre le Discord
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
);
